export const TokenActionTypes = {
  SET_TOKEN: 'SET_TOKEN',
  IS_AUTHENTICATED: 'IS_AUTHENTICATED',
  SET_USEEN_COUNT: 'SET_USEEN_COUNT',
  SET_IS_PASSWORD_RESET:'SET_IS_PASSWORD_RESET',
  RESET_TOKEN: "RESET_TOKEN"
};
